import { LOCALES } from '../locales';

const ArabicLanguage = {
    [LOCALES.ARABIC]: {
        'hello': 'مرحبا',
        'homepage': 'الرئيسيّة',
        'username' : 'اسم المستخدم',
        'password' : 'كلمة المرور',
        'newpassword' : ' كلمة المرور الجديدة',
        'confirm-newpassword' : '  تاكيد كلمة المرور      ',
        "bisharat" : 'بشارات',
        'email' : "البريد الالكتروني",
        'full-name' : ' الاسم الكامل',
        'phone-num' : 'رقم الهاتف ',
        'new-phone-num' : ' رقم الهاتف الجديد ',
        'permissions' : 'امتيازات',
        'bisharatfamily':' عائلة آل بشارات ',
        'familytree':'شجرة العائلة ',
        'loading-family-tree':'جاري تحميل شجرة العائلة...',
        'gallery':' جاليري صور ',
        'historical-info':'  معلومات تاريخيّه ',
        'about-us':'  كلمة الموقع  ',
        'login':'دخول',
        'login-now':' تسجيل دخول',
        'logout':'خروج',
        'already-logged' : 'مسجل في الموقع',
        'click-to-activate' : 'اضغط لتفعيل حسابك',
        'activated' : ' تم تفعيل حسابك بنجاح ',
        'not-activated' : ' لم يتم تفعيل حسابك  ',
        'adminboard' : 'Admin Board ',
        'user-pass-incorrect' : "اسم المستخدم او كلمة المرور غير صحيحة",
        'my-profile' : "ملف شخصي",
        'for-more-contact' : 'لمزيد من التفاصيل تواصل معنا',
        'contact-us' : "تواصل معنا ",
        'click-here' : " اضغط هنا  ",
        'read-more' : "    اقرأ المزيد  ",
        'specify' : 'الرجاء التفصيل',
        "send" : 'ارسال',
        'alert-email-sent' : 'سوف يتم ارسال رابط لتفعيل الحساب الى بريدك الالكتروني',
        'mail-sent-success' : ' تم ارسال الايميل بنجاح',
        'email-not-validated' : 'بريد الكتروني غير ملائم',
        'username-not-validated' : 'اسم المستخدم لا يمكن ان يحتوي فراغات ',
        'username-not-available' : '  اسم مستخدم غير ملائم',
        'name-not-appropriate' : 'الاسم غير ملائم  ',
        'not-appropriate' : 'غير ملائم',
        'password-not-appropriate' : ' كلمة المرور غير ملائمة  ',
        'password-more-than-8' : '   يجب ان تكون اكبر من 8 احرف   ',
        'numbers-only' : 'ارقام فقط ',
        'phone-10-digits' : '  رقم الهاتف الخليوي - 10 ارقام    ',
        'phone-example' : 'مثال : 0505123123',
        'some-instructions' : 'بعض النصائح والارشادات لتصفح شجرة العائلة بشكل افضل',
        'members-entrance' : ' الدخول للاعضاء المشتركين ومصرّح لهم بالدخول',  
        'use-chrome' : 'مفضّل استعمال متصفّح  Chrome  ',
        'scroll-sides' : ' الصفحة قابله للسحب يسار/يمين ',
        'click-to-open' : ' اضغط على الشخص لفتح الملف الخاص ',
        'see-full-profile' : 'بالامكان من خلال الملف الشخصي رؤية شجره العائله بداية من الشخص المحدد',
        'add-partner-succesfully' : ' اضافة شريك تمت بنجاح',
        'last-update' : '  اخر تحديث',
        'next-update' : '   التحديث القادم',
        'maaloul-village' : " قرية معلول",
        'maaloul-village-zochrot' : " معلول من موقغ ذاكرات ",
        'click-to-download-book' : " اضغط لتحميل/مشاهدة الكتيّب ",
        'welcome' : "اهلاً وسهلاً ",
        'mandatory' : "اجباري ",
        'join-now' : "انضم الان ",
        'join' : 'انضمام',
        'request-permission-bish' : "يجب الدخول الى 'الملف الشخصي' وطلب امتيازات العائله لمشاهده شجرة العائلة و محتويات الموقع",
        'msg-subject' : 'عنوان الرسالة',
        'msg-content' : 'موضوع الرسالة',
        'activities' : " فعاليات واحتفالات ",
        'notifications' : "اشعارات",
        'site-under-development': "الموقع ما زال جديداً وقيد التطوير",
        'welcoming-suggestions' : "كل فكرة او اقتراح مرحب به ",
        "too-much-tries" : "عدّة محاولات بدون نجاح - الرجاء التواصل معنا لتفعيل حسابك",
        "too-much-tries-change-number" : "عدّة محاولات بدون نجاح - الرجاء التواصل معنا  ",
        "number-changed-successfully" : " تم تغيير رقم الهاتف بنجاح ",
        "User-phone-confirmed" : "  تم المصادقة على رقم الهاتف.. يتم الان فحص هوية المشترك لاعطاء امتيازات العائلة",
        "back-to-main" : 'للصفحة الرئيسيّة',
        'pagenotfound' : 'صفحة غير موجودة',
        'back' : 'للعودة',
        "request-family-permissions" : '  طلب امتيازات العائلة',
        "family-per-content" : "هذا المحتوى بحاجه الى امتيازات العائله ",
        "restore-user-pass" : '  اعادة كلمة المرور او اسم المستخدم ',
        'check-ur-namil' : 'افحص البريد الالكتروني لتفعيل حسابك    ',
        "maaloul-parag-first" : "هي قرية فلسطينية تقع على بعد 12 كلم غرب الناصرة وحوالي 30 كلم جنوب غرب حيفا، وكيلومترين شمال قرية المجيدل حيث يفصل بينهما شارع رئيسي يصل بين حيفا والناصرة، وكانت طريق فرعية تربط معلول بالطريق العام.    معلول لفظة كنعانية معناها المدخل أو البوابة ومن المعتقد أنها أقيمت فوق المكان الذي كانت تقوم عليها أهالول أو مهلول الرومانية، وكانت تابعة في حينه لصفورية، وقد عرفها الصليبيون باسم ماعولا. ",
        "maaloul-parag-second" : "معلول في القسم الجنوبي من جبال الجليل الأسفل وترتفع 270 مترا عن سطح البحر. ويفصل وادي الحلبي أو الصفصاف الواقع في جنوبها الغربي بين أراضيها وأراضي قرية المجيدل. وتقع عين البص في شمالها الشرقي وعين البلد في شمالها الغربي.",
        'check-sms-req' : "شكراً : سوف يتم فحص الطلب والتأكد من هويّة المشترك",
        'code' : ' كود التفعيل',
        'verify-code' : 'تأكيد كود التفعيل ',
        'tries' : 'محاولات',
        "youve" : 'لديك',
        'changepassword' : ' تغيير كلمة المرور',
        'modifyphone' : '   تعديل رقم الهاتف',
        'newphone-used' : 'رقم الهاتف مستخدم ',
        'checkphone' : 'قبل طلب الأمتياز يرجى التاكد من رقم الهاتف',
        'sendsms': 'سوف يتم ارسال كود الى رفم الهاتف لتاكيد هويّة المشترك',
        'oldpass-notcorrect' : 'كلمة المرور غير صحيحة',
        'newpass-notsimilar' : 'كلمة المرور الجديدة غير متطابقة',
        'success-change-pass' : 'تم تغيير كلمة المرور بنجاح',
        'link-unavailable' : 'الرابط غير متاح',
        'notif' : 'اشعار',
        'publishdate' : 'تاريخ النشر',
        'activity' : 'الفعاليّة',
        'moredetails' : ' مزيد من المعلومات',
        "activity-link" : 'رابط الفعاليّة',
        "activity-date" : ' تاريخ الفعاليّة   ',
        "this-day-activity" : 'فعاليات يوم ال',
        'pick-date-act' : 'اختار تاريخ لمشاهدة الفعاليات',
        "oncoming-act" : ':جميع الفعاليات الفادمة',
        "name" : "الاسم",
        "father-name" : 'اسم الاب',
        "mother-name" : 'اسم الام',
        "family-name" : ' اسم العائلة ',
        "address" : 'العنوان',
        "partner" : 'الشريك/ة',
        'children' : 'الاطفال',
        "showPartner" : ' ملف الشريك/ة',
        "addPartner" : ' اضافة الشريك/ة',
        "birthdate" : 'تاريخ الميلاد',
        "gender" : 'الجنس',
        'notfound' : 'غير موجود',
        'fa-tree-person' : 'شجرة العائله للشخص',
        "edit" : 'تعديل',
        "add-child" : 'اضافة طفل',
        "profile-pic" : 'صورة بروفايل',
        "edit-profile-pic" : ' تعديل صورة بروفايل  ',
        "alive" : "على قيد الحياة؟",
        "yes" : 'نعم',
        "no" : 'كلا',
        "married" : "متزوج",
        "not-married" : "غير متزوج",
        "status-fam" : 'الحالة الاجتماعيّة',
        'identity' : 'رقم الهويّة',
        "male" : 'ذكر',
        "female" : 'انثى',
        'thanks-for-donation' : ' شكرًا جزيلاً ',
        'donation-text' : '  بدعمكم نواصل ونتقدّم',
      
    }
    
}


export default ArabicLanguage;